export default {
    "MAX_ITEMS_IN_CHECKLIST": 2000,
    "USER_LIST_PAGE_SIZE": 6,
    "ROLES": {
        "CUSTOMER": {
            "ID": 1,
            "NAME": "Customer"
        },
        "EMPLOYEE": {
            "ID": 2,
            "NAME": "Employee"
        },
        "PARTNER": {
            "ID": 3,
            "NAME": "Partner"
        }
    },
    "GROUPBY": {
        "ME": 0,
        "STORE": 1,
        "CITY": 2,
        "COUNTRY": 3,
        "POSITION": 4
    },
    "TIME": {
        "ALLTIME": 0,
        "THISYEAR": 1,
        "THISQUARTER": 2,
        "LAST6MONTH": 3,
        "THISMONTH": 4,
        "THISWEEK": 5,
        "CUSTOM": 6,
        "DATEFORMAT": "YYYY/MM/DD"
    },
    "LOCATION": {
        "GERMANY": {
            "LIVE": 56,
            "PILOT": 228
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/constants.js